import script from "./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue?vue&type=script&lang=js"

import "./TextElement.vue?vue&type=style&index=0&id=6dd83faa&lang=scss"

const __exports__ = script;

export default __exports__